var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#EEEFF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.798 32.8215C18.1869 32.8215 17.6713 32.6152 17.2511 32.2027C16.831 31.7902 16.6209 31.2784 16.6209 30.6673V17.9944H15.2917V15.8402H20.5855V14.7402H27.3917V15.8402H32.7084V17.9944H31.3792V30.6673C31.3792 31.2632 31.1654 31.7711 30.7376 32.1913C30.3098 32.6114 29.798 32.8215 29.2022 32.8215H18.798ZM29.2022 17.9944H18.798V30.6673H29.2022V17.9944ZM21.1126 28.8798H22.8772V19.7361H21.1126V28.8798ZM25.123 28.8798H26.9105V19.7361H25.123V28.8798ZM18.798 17.9944V30.6673V17.9944Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.4740d344e21d021ca4912de3d25dd024.svg";
export { ForwardRef as ReactComponent };